export default "__VITE_ASSET__BHLLGy7j__"